import { createReducer } from "../../common/reduxUtil";
import moment from "moment";

import {
  RESET_ALL_STATES,
  SET_IS_ACTIVE,
  SET_STAGE,
  SET_NAME,
  SET_STARTS_AT,
  SET_ENDS_AT,
  SET_DURATION,
  SET_DURATION_TYPE,
  SET_ATTEMPTS_ALLOWED,
  SET_VISIBILITY_PRIVATE,
  SET_IS_VIDEO_PROCTORING_ON,
  SET_IS_TAB_PROCTORING_ON,
  SET_ID,
  SET_STATE,
  SET_ALL_STATES,
  SET_TRIGGER,
  SET_SECTIONS,
  SET_CURRENT_SECTION_INDEX,
  SET_CURRENT_SECTION_TITLE,
  SET_EDIT_CURRENT_SECTION,
  SET_SHOW_ADD_QUESTION_MODAL,
  SET_QUESTION_TYPE,
  SET_QUESTION_OPTIONS,
  SET_QUESTIONS,
  SET_QUESTION_ANSWERS,
  SET_ASSESSMENT,
  SET_CURRENT_ANSWER,
  SET_CURRENT_QUESTION,
  SET_CURRENT_SECTION,
  SET_ALLOWED_ENTITIES,
  SET_SUPPORT_WIDGET_VISIBILITY,
  NEXT,
  PREVIOUS,
  END_ASSESSMENT,
  SET_TEST_INSTRUCTION,
  START_SYNC,
  END_SYNC,
  SET_PASSING_PERCENTAGE,
  SET_QUESTION_STATES,
  START_VIDEO_RECORDING,
  END_VIDEO_RECORDING,
  SET_QUESTION,
} from "./types";
import {
  AssessmentWorkflowStage,
  ClosingTimeIntervals,
  DurationType,
  AssessmentAllowedAttempts,
  AssessmentDurationDefaultValue,
  AssessmentWorkFlowTrigger,
  AssessmentState,
} from "../common/constants";

const initialState = {
  manage: {
    id: "",
    trigger: AssessmentWorkFlowTrigger.HOME_CREATE_CTA,
    isActive: false,
    stage: AssessmentWorkflowStage.DETAILS,
    name: "",
    startsAt: moment(new Date()),
    endsAt: ClosingTimeIntervals[0],
    duration: AssessmentDurationDefaultValue,
    durationType: DurationType.ASSESSMENT_BASED,
    attemptsAllowed: AssessmentAllowedAttempts[0],
    isVisibilityPrivate: true,
    isVideoProctoringOn: true,
    isTabProctoringOn: true,
    state: AssessmentState.DRAFT,
    sections: [
      {
        name: "Section 1",
      },
    ],
    currentSectionIdx: 0,
    currentSectionTitle: "Section 1",
    editCurrentSection: false,
    showAddQuestionModal: false,
    questionType: null,
    questionOptions: Array(2).fill({
      description: {
        response: "",
      },
    }),
    questionAnswers: [],
    allowedEntities: [],
    testInstructions: {},
    passingPercentage: null,
  },
  attempt: {
    hasTestEnded: false,
    details: {
      _id: null, // if null, means the data has not been loaded yet
      questionSet: [],
    },
    showSupportWidget: false,
    cursor: {
      section: {
        idx: null,
      },
      question: {
        idx: null,
        data: {},
      },
      answer: [],
    },
    isVideoRecording: false,
    isSyncing: false,
    lastSyncedAt: null,
    hasSyncError: false,
  },
};

export default createReducer(initialState, {
  //Manage
  [SET_IS_ACTIVE]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, isActive: payload.isActive };
    return _state;
  },
  [SET_STAGE]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, stage: payload.stage };
    return _state;
  },
  [SET_NAME]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, name: payload.name };
    return _state;
  },
  [SET_STARTS_AT]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, startsAt: payload.startsAt };
    return _state;
  },
  [SET_ENDS_AT]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, endsAt: payload.endsAt };
    return _state;
  },
  [SET_DURATION]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, duration: payload.duration };
    return _state;
  },
  [SET_DURATION_TYPE]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, durationType: payload.durationType };
    return _state;
  },
  [SET_ATTEMPTS_ALLOWED]: (state, payload) => {
    const _state = { ...state };
    _state.manage = {
      ..._state.manage,
      attemptsAllowed: payload.attemptsAllowed,
    };
    return _state;
  },
  [SET_VISIBILITY_PRIVATE]: (state, payload) => {
    const _state = { ...state };
    _state.manage = {
      ..._state.manage,
      isVisibilityPrivate: payload.isVisibilityPrivate,
    };
    return _state;
  },
  [SET_ALLOWED_ENTITIES]: (state, payload) => {
    const _state = { ...state };
    _state.manage = {
      ..._state.manage,
      allowedEntities: [...payload.allowedEntities],
    };
    return _state;
  },
  [SET_IS_VIDEO_PROCTORING_ON]: (state, payload) => {
    const _state = { ...state };
    _state.manage = {
      ..._state.manage,
      isVideoProctoringOn: payload.isVideoProctoringOn,
    };
    return _state;
  },
  [SET_IS_TAB_PROCTORING_ON]: (state, payload) => {
    const _state = { ...state };
    _state.manage = {
      ..._state.manage,
      isTabProctoringOn: payload.isTabProctoringOn,
    };
    return _state;
  },
  [SET_ID]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, id: payload.id };
    return _state;
  },
  [SET_STATE]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, state: payload.state };
    return _state;
  },
  [SET_TRIGGER]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, trigger: payload.trigger };
    return _state;
  },
  [SET_SECTIONS]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, sections: payload.sections };
    return _state;
  },
  [SET_CURRENT_SECTION_INDEX]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, currentSectionIdx: payload.index };
    return _state;
  },
  [SET_CURRENT_SECTION_TITLE]: (state, payload) => {
    const _state = { ...state };
    _state.manage = { ..._state.manage, currentSectionTitle: payload.title };
    return _state;
  },
  [SET_EDIT_CURRENT_SECTION]: (state, payload) => {
    const _state = { ...state };
    _state.manage = {
      ..._state.manage,
      editCurrentSection: payload.edit,
    };
    return _state;
  },
  [SET_SHOW_ADD_QUESTION_MODAL]: (state, payload) => {
    const _state = { ...state };
    _state.manage = {
      ..._state.manage,
      showAddQuestionModal: payload.showAddQuestionModal,
    };
    return _state;
  },

  [SET_QUESTION_TYPE]: (state, payload) => {
    const _state = { ...state };
    _state.manage = {
      ..._state.manage,
      questionType: payload.questionType,
    };
    return _state;
  },

  [SET_QUESTION_OPTIONS]: (state, payload) => {
    const _state = { ...state };
    _state.manage = {
      ..._state.manage,
      questionOptions: payload.questionOptions,
    };
    return _state;
  },
  [SET_QUESTIONS]: (state, payload) => {
    const prevState = state.manage;
    const _sections = [...prevState.sections];
    const _section = { ..._sections[prevState.currentSectionIdx] };
    _section["questions"] = payload.questions;
    _sections[prevState.currentSectionIdx] = _section;
    const _state = { ...prevState };
    _state.sections = _sections;

    return {
      ...state,
      manage: {
        ..._state,
      },
    };
  },

  [SET_QUESTION]: (state, payload) => {
    const prevState = state.manage;

    const _sections = [...prevState.sections];
    const _section = { ..._sections[prevState.currentSectionIdx] };
    const _questions = _section?.questions;
    let questionIndex;
    // find the question index in current question set
    _questions.forEach((_question, index) => {
      if (_question._id === payload.id) {
        questionIndex = index;
        return;
      }
    });
    _section["questions"][questionIndex] = payload.question;
    _sections[prevState.currentSectionIdx] = _section;
    const _state = { ...prevState };
    _state.sections = _sections;

    return {
      ...state,
      manage: {
        ..._state,
      },
    };
  },

  [SET_QUESTION_ANSWERS]: (state, payload) => {
    const _state = { ...state };
    _state.manage = {
      ..._state.manage,
      questionAnswers: payload.questionAnswers,
    };
    return _state;
  },

  [SET_TRIGGER]: (state, payload) => {
    return Object.assign({}, state, {
      manage: {
        ...state.manage,
        trigger: payload.trigger,
      },
    });
  },

  [SET_TEST_INSTRUCTION]: (state, payload) => {
    return Object.assign({}, state, {
      manage: {
        ...state.manage,
        testInstructions: payload.testInstructions,
      },
    });
  },

  [SET_PASSING_PERCENTAGE]: (state, payload) => {
    return Object.assign({}, state, {
      manage: {
        ...state.manage,
        passingPercentage: payload.passingPercentage,
      },
    });
  },

  [SET_QUESTION_STATES]: (state, payload) => {
    return Object.assign({}, state, {
      manage: {
        ...state.manage,
        ...payload,
      },
    });
  },

  [SET_ALL_STATES]: (state, payload) => {
    return Object.assign({}, state, {
      manage: {
        ...state.manage,
        ...payload,
      },
    });
  },

  [RESET_ALL_STATES]: (state) => {
    const _state = { ...state };
    _state.manage = {
      ...initialState.manage,
    };
    return _state;
  },

  // Attempt

  [SET_SUPPORT_WIDGET_VISIBILITY]: (state, payload) => {
    const _state = { ...state };
    _state.attempt = {
      ..._state.attempt,
      showSupportWidget: payload,
    };
    return _state;
  },

  [SET_ASSESSMENT]: (state, payload) => {
    const _state = { ...state };
    _state.attempt = {
      ..._state.attempt,
      details: payload.assessment,
    };
    return _state;
  },
  [SET_CURRENT_QUESTION]: (state, payload) => {
    const _state = { ...state };
    _state.attempt = {
      ..._state.attempt,
      cursor: {
        ...state.attempt.cursor,
        question: { idx: payload.idx, data: payload.data },
      },
    };
    return _state;
  },
  [SET_CURRENT_ANSWER]: (state, param) => {
    const _state = { ...state };
    _state.attempt = {
      ..._state.attempt,
      cursor: {
        ...state.attempt.cursor,
        answer: [
          ...(typeof param === "function"
            ? param(_state.attempt.cursor.answer || [])
            : param),
        ],
      },
    };
    return _state;
  },
  [SET_CURRENT_SECTION]: (state, payload) => {
    const _state = { ...state };
    _state.attempt = {
      ..._state.attempt,
      cursor: {
        ...state.attempt.cursor,
        section: { idx: payload.idx },
      },
    };
    return _state;
  },

  [NEXT]: (state) => {
    const _state = { ...state };
    const allSections = _state.attempt.details.questionSet;
    const currentQuestionIdx = _state.attempt.cursor.question.idx;
    const currentSectionIdx = _state.attempt.cursor.section.idx;

    const doesCurrentSectionHasNextQuestions = () => {
      return (
        currentQuestionIdx < allSections[currentSectionIdx].questions.length - 1
      );
    };

    const doesAssessmentHasNextSection = () => {
      return currentSectionIdx < allSections.length - 1;
    };

    if (doesCurrentSectionHasNextQuestions()) {
      _state.attempt.cursor.question = {
        idx: currentQuestionIdx + 1,
        data: allSections[currentSectionIdx].questions[currentQuestionIdx + 1],
      };
    } else {
      if (doesAssessmentHasNextSection()) {
        _state.attempt.cursor.section = {
          idx: currentSectionIdx + 1,
        };
        _state.attempt.cursor.question = {
          idx: 0,
          data: allSections[currentSectionIdx + 1].questions[0],
        };
      } else {
        _state.attempt.hasTestEnded = true;
      }
    }
    _state.attempt.cursor.answer = [];
    _state.attempt.lastSyncedAt = null;
    return _state;
  },

  [PREVIOUS]: (state) => {
    const _state = { ...state };
    const allSections = _state.attempt.details.questionSet;
    const currentQuestionIdx = _state.attempt.cursor.question.idx;
    const currentSectionIdx = _state.attempt.cursor.section.idx;

    const doesCurrentSectionHasPreviousQuestion = () => {
      return currentQuestionIdx > 0;
    };

    const doesAssessmentHasPreviousSection = () => {
      return currentSectionIdx > 0;
    };

    if (doesCurrentSectionHasPreviousQuestion()) {
      _state.attempt.cursor.question = {
        idx: currentQuestionIdx - 1,
        data: allSections[currentSectionIdx].questions[currentQuestionIdx - 1],
      };
    } else {
      if (doesAssessmentHasPreviousSection()) {
        _state.attempt.cursor.section = {
          idx: currentSectionIdx - 1,
        };
        _state.attempt.cursor.question = {
          idx: allSections[currentSectionIdx - 1].questions.length - 1,
          data: allSections[currentSectionIdx - 1].questions[
            allSections[currentSectionIdx - 1].questions.length - 1
          ],
        };
      }
    }
    _state.attempt.cursor.answer = [];
    _state.attempt.lastSyncedAt = null;
    return _state;
  },

  [START_SYNC]: (state) => {
    const _state = { ...state };
    _state.attempt = {
      ..._state.attempt,
      isSyncing: true,
      hasSyncError: false,
    };
    return _state;
  },

  [END_SYNC]: (state, { hasError }) => {
    const _state = { ...state };
    if (hasError) {
      _state.attempt = {
        ..._state.attempt,
        isSyncing: false,
        hasSyncError: true,
      };
    } else {
      _state.attempt = {
        ..._state.attempt,
        isSyncing: false,
        lastSyncedAt: new Date().valueOf(),
        hasSyncError: false,
      };
    }
    return _state;
  },

  [END_ASSESSMENT]: (state) => {
    const _state = { ...state };
    _state.attempt = {
      ..._state.attempt,
      hasTestEnded: true,
    };
    return _state;
  },

  [START_VIDEO_RECORDING]: (state) => {
    const _state = { ...state };
    _state.attempt = {
      ..._state.attempt,
      isVideoRecording: true,
    };
    return _state;
  },

  [END_VIDEO_RECORDING]: (state) => {
    const _state = { ...state };
    _state.attempt = {
      ..._state.attempt,
      isVideoRecording: false,
    };
    return _state;
  },
});
